import { type CompanyConfig, TimeFormat } from '../interface';

export const StorrdConfig: CompanyConfig = {
  id: '3fdfd174-48bb-4204-bc3c-0a0a92727589',
  lang: 'en',
  langs: ['en'],
  name: 'Storrd Ltd',
  nameSecondary: 'Storrd',
  currency: 'POUNS',
  currencyCode: 'GBP',
  officialName: 'Storrd Ltd',
  email: 'storrd@gmail.com',
  feedbackEmail: 'storrd@gmail.com',
  phonePlaceholder: '+44',
  defaultPhoneCode: '+44',
  ageRestricted: 18,
  timeZone: 'UK',
  minimalOrderFeeThreshold: 700,
  canonical: '',
  defaultVolumeDisplay: '1x',
  countryCode: 'UK',
  warehouse: {
    default: 'STORR',
    minimalOrderFeeWarehouseCodes: [],
    location: { lat: 51.54058182302906, lng: -0.14528973127724054 },
  },
  map: {
    center: { lat: 51.54058182302906, lng: -0.14528973127724054 },
    zoom: 12,
  },
  paymentMethods: ['gpay', 'applepay', 'visa', 'mc', 'cash'],
  availablePaymentMethods: ['stripe', 'adyen'],
  timeFormat: TimeFormat.h24,
  links: {
    cookie: '',
    deliveryZones: '',
    forRiders: '',
    affiliateProgram: import.meta.env.REACT_APP_AFFILIATE_PROGRAM_LINK,
    instagram: 'https://www.instagram.com/shopstorrd/',
    tiktok: 'https://www.tiktok.com/@storrdofficial',
    legals: {
      cookiePolicy: {
        label: 'cookiePolicy',
        link: '/legals#cookie-policy',
      },
      privacyPolicy: {
        label: 'privacyPolicy',
        link: '/legals#privacy-policy',
      },
      generalTradingPolicy: {
        label: 'generalTradingPolicy',
        link: '/legals#terms-of-service',
      },
    },
  },
  referral: {
    code: '',
    discount: '',
    minBasket: '',
    downloadAppLink: '',
  },
  appStoreUrl: {
    ios: '',
    android: '',
  },
  apis: {},
  license: {
    name: 'Storrd Ltd',
    numberPrinary: '',
  },
};
